import React from 'react'
import { DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { LangDropdown, UserAvatar } from '../../../../components/Component'
import { useGlobalStoreData } from '../../../../store/globalStore'
import { LANGUAGES } from '../../../../utils/Utils'
import EnglishFlag from '../../../../images/flags/english-sq.png'
import TurkeyFlag from '../../../../images/flags/turkey-sq.png'
import SaudiArabiaFlag from '../../../../images/flags/saudi-arabia-sq.png'

const LanguageHead = () => {
  const languageGSD = useGlobalStoreData.language()

  const languageFlagMap = {
    [LANGUAGES.TURKISH]: TurkeyFlag,
    [LANGUAGES.ARABIC]: SaudiArabiaFlag,
    [LANGUAGES.ENGLISH]: EnglishFlag
  }

  return (
    <UncontrolledDropdown className="language-dropdown">
      <DropdownToggle
        tag="a"
        href="#toggle"
        onClick={(ev) => ev.preventDefault()}
        className="dropdown-toggle nk-quick-nav-icon"
      >
        <UserAvatar className="border border-light xs">
          <img src={languageFlagMap[languageGSD] || EnglishFlag} alt=""/>
        </UserAvatar>
      </DropdownToggle>
      <LangDropdown className="dropdown-menu-s1"/>
    </UncontrolledDropdown>
  )
}

export default LanguageHead
